import { render, staticRenderFns } from "./postDynamic.vue?vue&type=template&id=e46f90aa&scoped=true"
import script from "./postDynamic.vue?vue&type=script&lang=js"
export * from "./postDynamic.vue?vue&type=script&lang=js"
import style0 from "./postDynamic.vue?vue&type=style&index=0&id=e46f90aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46f90aa",
  null
  
)

export default component.exports